import { RedoIcon } from 'Asset/icon';
import ButtonOutline from 'UiKit/button/buttonOutline';
import { TextSemiBold } from 'UiKit/typography';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

const SIZES = {
  small: { width: '70px', height: '28px', fontSize: 'var(--font-body3)', iconSize: '10px', borderRadius: 'var(--radius-sm)' },
  large: { width: '96px', height: '34px', fontSize: 'var(--font-body2)', iconSize: '14px', borderRadius: 'var(--radius-base)' },
};

const RetryButton = ({ size = 'small', onClick }) => {
  const { t } = useTranslation();
  const { width, height, fontSize, iconSize, borderRadius } = SIZES[size];
  return (
    <ButtonOutline borderWidth={'2px'} className={styles['retry-button']} style={{ width, height, borderRadius }} onClick={onClick}>
      <RedoIcon size={iconSize} color="var(--color-primary70)" />
      <TextSemiBold fontSize={fontSize} color="var(--color-primary70)">
        {t('retake')}
      </TextSemiBold>
    </ButtonOutline>
  );
};

export default RetryButton;
